import { render } from "./GdprYoutubePlayer.vue?vue&type=template&id=13a3b68a"
import script from "./GdprYoutubePlayer.vue?vue&type=script&lang=js"
export * from "./GdprYoutubePlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__